import { BRAND_SECONDARY_RGB } from "~/brandColors";
import type { ComponentPropsWithoutRef } from "react";

interface IconCloseXProps extends ComponentPropsWithoutRef<"svg"> {
  fillColor?: string;
}

export default function IconCloseX({
  fillColor = BRAND_SECONDARY_RGB,
  ...props
}: IconCloseXProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.00039 8.32519L1.95019 13.3754C1.76699 13.5586 1.54619 13.6502 1.28779 13.6502C1.02939 13.6502 0.808586 13.5586 0.625386 13.3754C0.442186 13.1922 0.350586 12.9714 0.350586 12.713C0.350586 12.4546 0.442186 12.2338 0.625386 12.0506L5.67559 7.00039L0.625386 1.95019C0.442186 1.76699 0.350586 1.54619 0.350586 1.28779C0.350586 1.02939 0.442186 0.808586 0.625386 0.625386C0.808586 0.442186 1.02939 0.350586 1.28779 0.350586C1.54619 0.350586 1.76699 0.442186 1.95019 0.625386L7.00039 5.67559L12.0506 0.625386C12.2338 0.442186 12.4546 0.350586 12.713 0.350586C12.9714 0.350586 13.1922 0.442186 13.3754 0.625386C13.5586 0.808586 13.6502 1.02939 13.6502 1.28779C13.6502 1.54619 13.5586 1.76699 13.3754 1.95019L8.32519 7.00039L13.3754 12.0506C13.5586 12.2338 13.6502 12.4546 13.6502 12.713C13.6502 12.9714 13.5586 13.1922 13.3754 13.3754C13.1922 13.5586 12.9714 13.6502 12.713 13.6502C12.4546 13.6502 12.2338 13.5586 12.0506 13.3754L7.00039 8.32519Z"
        fill={fillColor}
      />
    </svg>
  );
}
